'use client';

import { useApartmentReviewsContext } from './ApartmentReviewsProvider';
import { ReviewsShell, type ReviewSourceConfig } from './ReviewsShell';
import { ReviewsEntryPoint } from './ReviewsEntryPoint';

export function ApartmentReviewsModule() {
  const { lotId, reviews } = useApartmentReviewsContext();
  if (!reviews) return null;
  const sources: Array<ReviewSourceConfig> = [];
  if (reviews.reputation) sources.push({ id: 'web', label: 'Web reviews', panel: { status: 'unavailable' } });
  if (reviews.google)
    sources.push({
      id: 'google',
      label: 'Google',
      instanceKey: reviews.google.placeId,
      panel: { status: 'unavailable' },
    });
  if (reviews.reddit) sources.push({ id: 'reddit', label: 'Reddit', panel: { status: 'unavailable' } });
  return <ReviewsShell key={lotId} id="reviews" sources={sources} />;
}

export function ApartmentReviewsEntry() {
  const { reviews } = useApartmentReviewsContext();
  if (!reviews) return null;
  const { averageRating, totalReviews } = reviews.reputation ?? {};
  return (
    <ReviewsEntryPoint
      targetId="reviews"
      hasReputation={!!reviews.reputation}
      aggregateRating={
        averageRating !== undefined && totalReviews !== undefined
          ? { rating: averageRating, reviewCount: totalReviews }
          : null
      }
      hasGooglePlace={!!reviews.google}
      hasRedditLinks={!!reviews.reddit?.links.length}
    />
  );
}
